// extracted by mini-css-extract-plugin
export default {"container":"Chatbox_container__G1Q30","close-btn":"Chatbox_close-btn__SpAB6"};